import { render } from "./MoreInstituteDetails.vue?vue&type=template&id=7dc2f942&scoped=true"
import script from "./MoreInstituteDetails.vue?vue&type=script&lang=js"
export * from "./MoreInstituteDetails.vue?vue&type=script&lang=js"

import "./MoreInstituteDetails.vue?vue&type=style&index=0&id=7dc2f942&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc2f942"]])

export default __exports__